document.querySelectorAll('.links-footer .footer-content a').forEach(ele => {
  if (ele.innerText == 'コーポレートサイト') {
    ele.target = '_blank';
  }
});

document.querySelectorAll(".homepage-featured-content-box .homepage-sections--title").forEach(ele => {
  ele.innerHTML = ele.innerHTML
    .replace(/(>)\s+/g, "$1")
    .replace(/\s+([<>])/g, "$1")
    .replace(/[\r\n]/g, "");
});


const nav = document.querySelector('#toggle-menu .nav');

nav.append(document.querySelector('.footer-main').cloneNode(true));

const camp = document.getElementById('shopify-section-template--21541763121402__gallery_slideshow_HgzJ8Y');
if (camp) {
  camp.querySelectorAll('.content-grid-item__content').forEach(ele => {
    nav.append(ele.cloneNode(true));
  });
}

const recom = document.getElementById('shopify-section-template--21541763121402__collage_beet4y');
if (recom) {
  recom.querySelectorAll('.collage-builder__grid-item--inner').forEach(ele => {
    if (!ele.querySelector('.collage-builder__image')) {
      const img = document.createElement('div');
      img.classList.add('collage-builder__image');
      img.classList.add('bg');
      ele.querySelector('.collage-builder__text-container').after(img);
    }
    ele.addEventListener('click', (e) => {
      const a = ele.querySelector('a');
      a.dispatchEvent(new PointerEvent("click"));
    });
    //ele.append(link);
  });
}

if (document.querySelector('.section--collection-header')) {
  const bar = document.getElementById('shopify-section-sections--21541763580154__announcement-bar');
  const header = document.getElementById('shopify-section-sections--21541763580154__header');
  header.after(bar);
}

if (document.querySelector('.social-icons .copy-url')) {
  const copy = document.querySelector('.social-icons .copy-url');
  copy.addEventListener('click', (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(window.location.href)
    .then(() => {
      //
    })
    .catch(err => {
      console.error('コピーに失敗しました', err);
    });
  });
}

if (document.getElementById('add-description')) {
  let note = document.getElementById('add-description');
  note.remove();
  if (note.innerText.length > 0) {
    const lines = document.querySelectorAll('.product-form-separator.product-form-block');
    const p = document.createElement('div');
    p.classList.add('product-block-richtext');
    p.innerHTML = '<p><u>' + note.innerText + '</u></p>';
    //console.log(lines.length);
    lines[lines.length - 1].before(p);
  }
}
if (document.getElementById('metafields-sort')) {
  let sort = document.getElementById('metafields-sort');
  sort.remove();
  if (sort.innerText.length > 0) {
    const parent = document.querySelector('.metafields_pattern-wrapper');
    sort = sort.innerText.split('-');
    sort.forEach(num => {
      const sec = document.querySelector('.metafields_pattern' + num);
      if (sec) {
        parent.append(sec);
      }
    });
  }
}
if (document.getElementById('free-shipping-badge')) {
  let free = document.getElementById('free-shipping-badge');
  const parent = document.querySelector('div[data-block-id="text_Vn6mmM"] p');
  parent.innerHTML = free.innerHTML;
  free.remove();
}

if (document.querySelector('.metafields_pattern02')) {
  const slide = document.querySelector('.metafields_pattern02 .slide');
  slide.append(document.querySelector('.metafields_pattern02 ul').cloneNode(true));
  const pager = document.createElement('div');
  pager.classList.add('swiper-pagination');
  slide.append(pager);
  new Swiper(slide, {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

if (document.querySelector('.product-single div[data-product-badge]')) {
  const badge = document.querySelector('.product-single div[data-product-badge]');
  document.querySelector('.product-item-tags').append(badge);
}


if (document.querySelector('.fixed_buy')) {
  const btn = document.querySelector('.fixed_buy a');
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.querySelector('.product-form');
    const wh = window.innerHeight;
    let pos = target.getBoundingClientRect().top + document.documentElement.scrollTop - wh;
    const cart = document.querySelector('.paymentButtonsWrapper');
    pos += cart.offsetHeight + document.querySelector('.fixed_buy').offsetHeight + 20;
    window.scrollTo({ top: pos, behavior: 'smooth' });
  });
}


const buyNowButton = document.getElementById('custom-buy-now');
const productForm = document.querySelector('form[action*="/cart/add"]');

if (buyNowButton && productForm) {
  buyNowButton.addEventListener('click', function (e) {
    e.preventDefault();

    const quantity = document.getElementById('Quantity');

    // ボタンを無効化（連続クリック防止）
    buyNowButton.disabled = true;
    buyNowButton.innerHTML = '<span>処理中...</span>';

    // フォームデータを取得
    const formData = new FormData(productForm);
    formData.append('quantity', quantity.value);

    // Ajax APIでカートに追加
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // チェックアウトページにリダイレクト
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
        alert('エラーが発生しました。もう一度お試しください。');
        buyNowButton.disabled = false;
        buyNowButton.innerHTML = '<span>今すぐ購入</span>';
      });
  });
}


document.querySelectorAll('.parallax-content-wrapper').forEach((ele) => {
  new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const target = entry.target;
      if (entry.isIntersecting) {
        if (!target.classList.contains('show')) {
          target.classList.add('show');
        }
        else {
          //target.classList.remove('show');
        }
      }
    });
  }, { threshold: 0 }).observe(ele);
});

document.querySelectorAll('.section--spotlight-image-with-text').forEach(ele => {
  const link = ele.querySelector('a');
  //console.log(link);
  if (link) {
    const wrap = ele.querySelector('.responsive-image-wrapper');
    const link2 = document.createElement('a');
    link2.setAttribute('href', link.getAttribute('href'));
    wrap.append(link2);
    link2.append(wrap.querySelector('img'));
  }
});

const root = document.querySelector('#shopify-section-template--21541763121402__featured_collection_WrN6qx .grid-uniform');
if (root) {
  let count = 0;
  root.querySelectorAll('.grid__item .grid-view-item-tags').forEach(ele => {
    ++count;
    const label = document.createElement('i');
    label.classList.add('rank');
    label.classList.add('rank' + count);
    label.innerHTML = count;
    ele.prepend(label);
  });
  const button = root.querySelector('.swiper-btn--wrapper');
  const ranking = root.querySelector('.swiper-wrapper');
  //const bar = root.querySelector('.swiper-scrollbar');
  const pager = document.createElement('div');
  const slider = document.createElement('div');
  pager.classList.add('pager');
  slider.classList.add('swiper');
  slider.classList.add('custom');
  slider.append(button.cloneNode(true));
  slider.append(ranking.cloneNode(true));
  slider.append(pager);
  //slider.append(bar.cloneNode(true));
  root.after(slider);

  const script = document.createElement('script');
  script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js');
  root.append(script);

  setTimeout(function () {
    new Swiper(slider, {
      loop: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: slider.querySelector('.swiper-button--next'),
        prevEl: slider.querySelector('.swiper-button--prev'),
      },
      pagination: {
        el: slider.querySelector('.pager'),
        clickable: true,
      },
    //  scrollbar: {
    //    el: slider.querySelector('.swiper-scrollbar'),
    //    draggable: true,
    //  },
    });
  }, 1000);
}


const provinceSelects = document.querySelectorAll('select[name="address[province]"]');
if (provinceSelects.length > 0) {
  setInterval(function () {
    const prefectureOrder = [
      '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
      '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
      '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
      '岐阜県', '静岡県', '愛知県', '三重県',
      '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
      '鳥取県', '島根県', '岡山県', '広島県', '山口県',
      '徳島県', '香川県', '愛媛県', '高知県',
      '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
    ];

    // すべての都道府県セレクトボックスを取得
    const provinceSelects = document.querySelectorAll('select[name="address[province]"]');

    provinceSelects.forEach(function (select) {
      if (!select.classList.contains('done')) {
        if (select.options.length > 0 && select.options[1]) {
          select.classList.add('done');
          // 既存のオプションを配列に格納
          const options = Array.from(select.options);

          // カスタム順序でソート
          options.sort(function (a, b) {
            const indexA = prefectureOrder.indexOf(a.text);
            const indexB = prefectureOrder.indexOf(b.text);
            return indexA - indexB;
          });

          // ソート済みオプションを追加
          options.forEach(function (option) {
            select.add(option);
          });
        }
      }
    });

  },1000);

}